import React, { useState, useEffect } from "react";
import "../style/InsertProduct.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { FaBox, FaPlus, FaArrowLeft, FaCheck } from "react-icons/fa";
import { getAllGoods } from "../api/goodsApi";

const InsertProduct = ({ onProductsAdded, onClose, isInModal = true }) => {
  const navigate = useNavigate(); 

  const [rows, setRows] = useState([
    { id: Date.now(), product: "", type: "", delivered: 0, received: 0, srNo: 1, goodsItemId: null },
  ]);

  const [goods, setGoods] = useState([]);
  const [goodsLoading, setGoodsLoading] = useState(true);

  // Fetch goods from API
  useEffect(() => {
    const fetchGoods = async () => {
      try {
        setGoodsLoading(true);
        const response = await getAllGoods();
        console.log("Goods API response:", response);
        setGoods(response.data?.data || response.data || []);
      } catch (error) {
        console.error("Error fetching goods:", error);
        toast.error("Failed to load products");
      } finally {
        setGoodsLoading(false);
      }
    };
    fetchGoods();
  }, []);

  const handleDone = () => {
    const validRows = rows.filter(
      (r) => r.product && (r.delivered > 0 || r.received > 0)
    );

    if (validRows.length === 0) {
      toast.error("Please add at least one product.");
      return;
    }

    if (onProductsAdded) {
      onProductsAdded(validRows);
    }
    
    toast.success("Product is added successfully!");
    
    if (onClose) {
      onClose();
    } else {
      navigate("/dashboard", {
        state: { products: validRows },
      });
    }
  };


  const handleBack = () => {
    if (onClose) {
      onClose();
    } else {
      navigate("/dashboard"); 
    }
  };

  const handleAddRow = () => {
    setRows([
      ...rows,
      {
        id: Date.now(),
        product: "",
        type: "",
        delivered: 0,
        received: 0,
        srNo: rows.length + 1,
        goodsItemId: null,
      },
    ]);
  };

  const handleInputChange = (id, field, value) => {
    setRows(
      rows.map((r) => (r.id === id ? { ...r, [field]: value } : r))
    );
  };

  const handleRemoveRow = (id) => {
    const filtered = rows.filter((r) => r.id !== id);
    const reNumbered = filtered.map((r, idx) => ({ ...r, srNo: idx + 1 }));
    setRows(reNumbered);
  };

  return (
    <div className="insert-product-container">
      <ToastContainer position="top-right" autoClose={2000} />
      
      <div className="insert-product-card">
        {/* ===== HEADER ===== */}
        <div className="insert-product-header">
          <div className="insert-product-header-left">
            <div className="insert-product-avatar">
              <FaBox />
            </div>
            <div className="insert-product-details">
              <h2 className="insert-product-title">Insert Product</h2>
              <p className="insert-product-subtitle">
                Add products for challan entry
                {!goodsLoading && goods.length > 0 && (
                  <span style={{ color: '#28a745', marginLeft: '10px' }}>
                    ({goods.length} products loaded)
                  </span>
                )}
              </p>
            </div>
          </div>
          <div className="top-buttons">
            <button className="btn-back" onClick={handleBack}>
              <FaArrowLeft /> Back
            </button>
            <button className="btn-done" onClick={handleDone}>
              <FaCheck /> Done
            </button>
          </div>
        </div>

        {/* ===== TABLE SECTION ===== */}
        <div className="table-wrapper">
          <div className="header-row">
            <span>Product</span>
            <span>Type</span>
            <span>Delivered Qty</span>
            <span>Received Qty</span>
            <span>Sr No</span>
            <span>Action</span>
          </div>

          {rows.map((row) => (
            <div className="data-row" key={row.id}>
              <select
                className="input-select"
                value={row.product}
                onChange={(e) => {
                  const selectedGood = goods.find(g => g.name === e.target.value);
                  console.log("Selected good:", selectedGood);
                  console.log("Available goods:", goods);
                  handleInputChange(row.id, "product", e.target.value);
                  if (selectedGood) {
                    handleInputChange(row.id, "goodsItemId", selectedGood.id);
                  }
                }}
                disabled={goodsLoading}
              >
                <option value="">
                  {goodsLoading ? "Loading products..." : "Select Product"}
                </option>
                {!goodsLoading && goods.length === 0 && (
                  <option value="" disabled>No products available</option>
                )}
                {!goodsLoading && goods.map((item) => (
                  <option key={item.id} value={item.name}>
                    {item.name}
                  </option>
                ))}
              </select>

              <input
                className="input-text"
                type="text"
                placeholder="Type"
                value={row.type}
                onChange={(e) =>
                  handleInputChange(row.id, "type", e.target.value)
                }
              />

              <input
                className="input-number"
                type="number"
                min="0"
                value={row.delivered}
                onChange={(e) =>
                  handleInputChange(row.id, "delivered", e.target.value)
                }
              />

              <input
                className="input-number"
                type="number"
                min="0"
                value={row.received}
                onChange={(e) =>
                  handleInputChange(row.id, "received", e.target.value)
                }
              />

              <span className="sr-no">{row.srNo}</span>

              <button
                className="btn-delete"
                onClick={() => handleRemoveRow(row.id)}
              >
                ×
              </button>
            </div>
          ))}
        </div>

        {/* ===== ADD PRODUCT BUTTON ===== */}
        <div className="add-product-section">
          <button className="btn-add" onClick={handleAddRow}>
            <FaPlus /> Add Product
          </button>
        </div>
      </div>
    </div>
  );
};

export default InsertProduct;
